import React from "react";
import { ColorProps, SpaceProps, TypographyProps, LayoutProps } from "styled-system";
import { Box } from "../Box";

interface Props {
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

export const Title: React.FC<Props & ColorProps & LayoutProps & TypographyProps & SpaceProps> = ({ as, children, ...restProps }) => (
  <Box as={as} {...restProps}>
    {children}
  </Box>
);

Title.defaultProps = {
  as: "h1",
};
